<template>
    <div class="demo">
        <img src="https://uccn.zhichubao.com/mobile/form_round.png" alt="" class="image">
        <div class="form">
            <div class="step1" v-if="step == 1">
                <div class="title">欢迎获取客户案例!</div>
                <div class="line">
                    <div>
                        <span>*</span>
                        <span>电子邮箱</span>
                    </div>
                    <input type="text" placeholder="请输入电子邮箱" v-model="form.email">
                </div>
                <div class="line">
                    <div>
                        <span>*</span>
                        <span>企业名称</span>
                    </div>
                    <input type="text" placeholder="请输入企业名称" v-model="form.enterpriseName">
                </div>
                <div class="line">
                    <div>
                        <span>*</span>
                        <span>案例</span>
                    </div>
                    <input type="text" placeholder="请输入案例" v-model="form.projectName">
                </div>
                <div class="btn" @click="submit">提交获取</div>         
           </div>
           <div class="step2" v-else-if="step == 2">
                <div class="title">为了您更快获取方案<br>请您补充以下信息!</div>
                <div class="phone br">
                    <div>中国大陆 086</div>
                    <input placeholder="请填写手机号" type="tel" maxLength="11" v-model="form.mobile">
                </div>
                <div class="code">
                    <input placeholder="验证码" type="tel" maxLength="6" class="br" v-model="form.checkCode">
                    <div class="br" @click="!disabled ? getCode() : ''">{{ codeText }}</div>
                </div>
                <input type="text" class="br" placeholder="请输入您的姓名">
                <div class="btn" @click="submit">提交获取</div>
           </div>
           
           <div class="step3" v-else-if="step == 3">
               <img src="https://uccn.zhichubao.com/mobile/form_close.png" alt="" class="close" @click="$router.go(-1)">
               <div>提交成功,<br>我们会尽快为您<br>发送解决方案!</div>
               <div>{{ time }}秒后自动关闭</div>
           </div>
        </div>
        <footer>
            <div>构建万商互联的<br>可信智能商业网络</div>
            <div>Build a trusted and intelligent business network that<br> connects thousands of businesses</div>
            <div></div>
        </footer>
    </div>
</template>

<script>
import { customer, customerSms } from '@/api'
import { Toast } from 'vant';
export default {
   data() {
       return {
           step:  1,
           form: {
               id: null,
               checkCode: '',
               email: '',
               enterpriseName: '',
               projectName: '',
               userApplyName: '',
               mobile: ''
           },
           codeText: '获取验证码',
           disabled: false,
           pageBackTimer: null,
           codeCountDown: null,
           time: 5
       }
   },
   methods:{
       submit(){
           let { checkCode, email, enterpriseName, projectName, id, userApplyName, mobile} = this.form;
           let data;
           if(this.step == 1){
               data = {
                  email,
                  enterpriseName,
                  projectName,
                  checkFlag: false
               }
               let reg = /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/
               if ( !email ) {
                    Toast("请输入邮箱");
                    return;
                }else if( !reg.test(email) ){
                    Toast("请输入正确格式的邮箱");
                    return;
                }else if( !enterpriseName ){
                    Toast("请输入企业名称");
                    return;
                }else if( !projectName ){
                    Toast("请输入案例");
                    return;
                }
           }else{
               data = {
                  checkCode,
                  userApplyName,
                  mobile,
                  id,
                  checkFlag: true
              }
              let reg = /^1(3|4|5|6|7|8)\d{9}$/
              if ( !mobile ) {
                 Toast("请输入手机号");
                 return;
              }else if( !reg.test(mobile) ){
                 Toast("请输入正确格式的手机号");
                 return;
              }else if( !checkCode ){
                 Toast("请输入验证码");
                 return;
              }
           }
           customer(data).then( res => {
               this.form.id = res.result;
               this.step++;
               if( this.step == 3){
                   this.pageBackTimer = setInterval( () => {
                       this.time --;
                       if( this.time == 0 ){
                            this.$router.go(-1)
                            clearInterval(this.pageBackTimer)
                       }
                   },1000)
               }
           })
       },
       async getCode() {
        let reg = /^1(3|4|5|6|7|8)\d{9}$/
        if (this.form.mobile == "") {
            Toast("请输入手机号");
        }else if( !reg.test(this.form.mobile) ){
            Toast("请输入正确格式的手机号");
        } else {
            await customerSms({ mobile: this.form.mobile, id: this.form.id });
            let maxNum = 60;
            let oldCodeText = this.codeText;
            this.codeText = `${maxNum}s后重新获取`; //初始显示倒计时
            this.codeCountDown = setInterval(() => {
            this.disabled = true;
            let countDownNum = maxNum--;
            this.codeText = `${countDownNum}s重新发送`;
            if (countDownNum == 0) {
                //倒计时结束
                this.codeText = oldCodeText;
                clearInterval(this.codeCountDown);
                this.disabled = false;
            }
            }, 1000);
        }
        }
   },
   destroyed(){
       clearInterval(this.pageBackTimer);
       clearInterval(this.codeCountDown);
   }
}
</script>

<style lang="scss" scoped>
footer{
    text-align: center;
    margin-top: 100px;
    div:nth-of-type(1){
        font-size: 44px;
        font-weight: bold;
        color: #383838;
        line-height: 60px;
    }
    div:nth-of-type(2){
        font-size: 22px;
        font-weight: 400;
        color: #383838;
        line-height: 30px;
        margin-top: 39px;
    }
    div:nth-of-type(3){
        width: 121px;
        height: 6px;
        background: #FFFFFF;
        margin: 40px auto 0;
    }
}
.form{
    box-sizing: border-box;
    width: 600px;
    background: #FFFFFF;
    box-shadow: 2px 7px 15px 1px rgba(56,56,56,0.1300);
    border-radius: 11px;
    margin: 0 auto;
    padding: 50px;
    .title{
        font-size: 38px;
        font-weight: bold;
        color: #FF6700;
    }
    .br{
        height: 61px;
        background: #FFFFFF;
        border: 1px solid #383838;
        border-radius: 8px;
    }
    .phone{
        display: flex;
        align-items: center;
        div{
            font-size: 22px;
            color: #383838;
            border-right: 1px solid #383838;
            padding: 0 14px 0 17px;
        }
        input{
            font-size: 22px;
            border: none;
            color: #383838;
            padding: 0 14px;
            flex: 1;
            background: transparent;
        }
    }
    .code{
        display: flex;
        margin-top: 39px;
        input{
           width: 247px;
           font-size: 22px;
           padding: 0 17px;
           margin-right: 18px;
        }
        div{
           flex: 1;
           border: 1px solid #FF6700;
           text-align: center;
           line-height: 61px;
           color: #FF6700;
        }
    }
    .btn{
        width: 224px;
        height: 60px;
        background: #FF6700;
        border-radius: 8px;
        text-align: center;
        line-height: 60px;
        margin: 0 auto;
        font-size: 24px;
        font-weight: bold;
        color: #FFFFFF;
    }
    .line{
        display: flex;
        align-items: center;
        font-size: 22px;
        color: #383838;
        margin-top: 19px;
        div{
            width: 110px;
            span:nth-of-type(1){
                color: #FF6700;
            }
        }
        input{
            flex: 1;
            height: 61px;
            background: #FFFFFF;
            border: 1px solid #383838;
            border-radius: 8px;
            padding: 0 17px;
            font-size: 22px;
            color: #383838;
        }
    }
    .step1{
        .title{
            margin-bottom: 50px;
        }
        .btn{
            margin-top: 50px;
        }
    }
    .step2{
        .title{
            margin-bottom: 50px;
        }
        .btn{
            margin-top: 50px;
        }
        &>input{
            margin-top: 19px;
            padding: 0 17px;
            width: -webkit-fill-available;
        }
    }
    .step3{
        text-align: center;
        height: 462px;
        position: relative;
        overflow: hidden;
        div:nth-of-type(1){
            font-size: 38px;
            font-weight: bold;
            color: #FF6700;
            line-height: 60px;
            margin-top: 90px;
        }
        div:nth-of-type(2){
            font-size: 22px;
            color: #383838;
            line-height: 41px;
            margin-top: 100px;
        }
        .close{
            position: absolute;
            top: 0;
            right: 0;
            width: 30px;
            height: 30px;
        }
    }
}
.demo{
    min-height: 100vh;
    overflow: hidden;
    background: #E6E6E6 url('../../assets/form_bac.png') no-repeat fixed right bottom;
    background-size: 722px 788px;
}
.image{
    width: 114px;
    height: 114px;
    margin: 110px 0 0 153px;
}
</style>
